const offlineAlarm = {
  AlarmInfo: "报警信息",
  Type: "报警类型",
  faultTime: "报警时间",
  startTime: "报警开始时间",
  endTime: "报警结束时间",
  type1: "防拆",
  type2: "信号丢失"
} 
export default offlineAlarm